// src/components/common/Toast.tsx
import { toast } from "sonner";

interface ToastOptions {
    description?: string;
}

export const showSuccessToast = (message: string, options?: ToastOptions) => {
    toast.success(message, {
        description: options?.description,
        style: {
            backgroundColor: '#e6f4ea',
            color: '#333333',
            border: '1px solid #218838'
        },
        className: 'text-[#218838]'
    });
};

export const showErrorToast = (message: string, options?: ToastOptions) => {
    toast.error(message, {
        description: options?.description,
        style: {
            backgroundColor: '#f8d7da',
            color: '#333333',
            border: '1px solid #c82333'
        },
        className: 'text-[#c82333]'
    });
}; 